import * as React from "react";
import { Grid, TextField } from "@mui/material";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from "@mui/material/Autocomplete";
import { Box } from "@mui/system";
import Message from "../../Components/common/Message";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import { Button, Col, Flex, Row } from "antd";

const Auth = new AuthService();

export default function User() {
  const navigate = useNavigate();
  const params = useParams();
  var layoutDispatch = useLoadingDispatch();

  const [id, setId] = React.useState(params.id ? params.id : 0);

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [userType, setUserType] = React.useState({ id: 1, title: "Admin" });
  
  const [userStatus, setUserStatus] = React.useState({
    id: "1",
    title: "Active",
  });
  const [userRole, setUserRole] = React.useState();
  const [firstNameError, setFirstNameError] = React.useState("");
  const [lastNameError, setLastNameError] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");


  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (id > 0) {
      showLoading(layoutDispatch);
      Auth.fetch(`/user/user?id=${id}`)
        .then((res) => {
          hideLoading(layoutDispatch);
          if (res.ack) {
            setFirstName(res.user.first_name);
            setLastName(res.user.last_name);
            setEmail(res.user.email);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const onClickCancel = () => {
    navigate("/users");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (firstName === "") {
      setFirstNameError("Required");
      return;
    } else {
      setFirstNameError("");
    }

    if (lastName === "") {
      setLastNameError("Required");
      return;
    } else {
      setLastNameError("");
    }

    if (email === "") {
      setEmailError("Required");
      return;
    } else {
      setEmailError("");
    }


    if (id > 0) {
      showLoading(layoutDispatch);
      const data = {
        first_name: firstName,
        las_name: lastName,
        email: email,
        id: Number(id),
        password: password,
      };
      Auth.fetch("/user/user", {
        method: "PUT",
        body: JSON.stringify(data),
      })
        .then((res) => {
          hideLoading(layoutDispatch);
          if (res.ack === true) {
            setType("success");
            setLoadMessage(res.message);
            setTimeout(() => {
              navigate("/users");
            }, 1000);
            setLoading(false);
          } else {
            setType("error");
            setLoadMessage(res.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setLoading(true);
      showLoading(layoutDispatch);
      const data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
      };
      Auth.fetch("/user/user", {
        method: "POST",
        body: JSON.stringify(data),
      })
        .then((res) => {
          hideLoading(layoutDispatch);
          if (res.ack === true) {
            setType("success");
            setLoadMessage(res.message);
            setTimeout(() => {
              navigate("/users");
            }, 1000);
            setLoading(false);
          } else {
            setType("error");
            setLoadMessage(res.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "100%" },
        }}
        noValidate
        autoComplete="off"
      >
        <h1> {id > 0 ? "Update" : "Add"} User</h1>
        <div>
          <Row gutter={[16,2]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
            <TextField
              value={firstName}
              onChange={(event) => {
                setFirstName(event.target.value);
              }}
              size="small"
              label="First Name"
              id="firstName"
              error={firstNameError === "" ? false : true}
              helperText={firstNameError}
            />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
            <TextField
              value={lastName}
              size="small"

              onChange={(event) => {
                setLastName(event.target.value);
              }}
              label="Last Name"
              id="lastName"
              error={lastNameError === "" ? false : true}
              helperText={lastNameError}
            />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
            <TextField
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              label="Email"
              id="email"
              size="small"

              error={emailError === "" ? false : true}
              helperText={emailError}
            />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
            <TextField
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              label="Password"
              type="password"
              size="small"

              id="password"
              // error={lastNameError === "" ? false : true}
              // helperText={lastNameError}
            />
            </Col>
            
          </Row>
        </div>

       
        <Flex justify="end" gap={5}>
          <Button  onClick={onClickCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Flex>

        <Message type={type} msg={loadMessage} />
      </Box>
    </div>
  );
}
